import { updateReduxObjKeyHandleDelete } from 'utils/objectManipulate';
export const UPDATE_SETTING_MGM_REFERRAL = 'UPDATE_SETTING_MGM_REFERRAL';

const reducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_SETTING_MGM_REFERRAL: {
            return updateReduxObjKeyHandleDelete(state, action.payload, action.updateAction);
        }
        default:
            return state;
    }
};

export function updateSettingMGMReferral(payload) {
    return {
        type: UPDATE_SETTING_MGM_REFERRAL,
        payload
    };
}

export default reducer;
